module.exports = __webpack_public_path__ + "assets/448c34a56d699c29117adc64c43affeb.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2
 ** module id = 1762
 ** module chunks = 1
 **/